import i18next from "i18next";
import "../css/cjk.css";

const LANGS = ["ru", "en", "cn"];

export const getLang = () =>
  localStorage.getItem("navic_lang") || process.env.REACT_APP_DEFAULT_LANG || "en";

// Приводит локаль вида "ru-RU" / "zh-Hans-CN" / "en_US" к одному из наших LANGS.
// Нужно для системной локали телефона, которую передаёт нативная обёртка
// (?lang= при первой загрузке) и для фолбэка на navigator.language.
// Возвращает null, если сопоставить не удалось — вызывающий решает, что делать.
export const normalizeLang = (raw) => {
  if (!raw) return null;

  const base = String(raw).toLowerCase().replace(/_/g, "-").split("-")[0];

  if (base === "zh") return "cn";
  if (LANGS.indexOf(base) >= 0) return base;
  return null;
};

// Локаль для Intl. Наш код китайского — "cn", а такого языка Intl не знает
// и молча форматирует по локали системы: даты в китайском шли по-русски.
const INTL_LOCALES = { ru: "ru-RU", en: "en-US", cn: "zh-CN" };

export const intlLocale = (lang = i18next.language) => INTL_LOCALES[lang] || "ru-RU";

// Перевод для строк, которые могут понадобиться до инициализации i18next.
// Глобальный i18next из src/i18n.js создаётся БЕЗ ресурсов: их подкладывают
// initLanguage (режим «визитка») и MainPage.setLanguage (кабинет), то есть уже
// после входа. На публичных страницах кабинета t() до этого возвращает сам ключ,
// и пользователь увидел бы «network_error» вместо текста.
export const tSafe = (key) => {
  const text = i18next.t(key);
  if (text !== key) return text;

  try {
    const lang = getLang();
    // Тот же require, что и в initLanguage: все три словаря и так в бандле.
    return require(`../_lang/${lang}.json`)[lang].translation[key] || key;
  } catch (e) {
    return key;
  }
};

// Подпись языка в переключателе. Латинские коды человек читает как есть,
// а «CN» китайцу ничего не говорит — на своём языке язык называется 中文
// (пункт 23 QA-таблицы). Подпись всегда на том языке, который она обозначает:
// так переключатель понятен независимо от текущего языка интерфейса.
const LANG_LABELS = { ru: "RU", en: "EN", cn: "中文" };

export const langLabel = (lang) => LANG_LABELS[lang] || String(lang || "").toUpperCase();

// Класс на body, по которому cjk.css поднимает мелкие размеры шрифта:
// иероглифы в 8-11px нечитаемы, латиница в тех же размерах — нормальный дизайн.
// Вызывать после каждой смены языка (сама смена языка страницу не перезагружает).
export const applyLangClass = (lang) => {
  const current = lang || getLang();

  if (typeof document === "undefined" || !document.body) return;

  LANGS.forEach((item) => document.body.classList.remove(`lang-${item}`));
  document.body.classList.add(`lang-${current}`);
};

export const initLanguage = () => {
  const lang = getLang();
  i18next.init({
    lng: lang,
    resources: require(`../_lang/${lang}.json`),
  });
  applyLangClass(lang);
};

// Смена языка на лету: запомнить, переинициализировать i18next, поправить класс
// на body. Перерисовку не вызывает — тексты берутся синхронным i18next.t,
// поэтому вызывающий сам решает, что перерендерить.
export const setLanguage = (lang) => {
  const normalized = normalizeLang(lang);
  if (!normalized) return false;

  localStorage.setItem("navic_lang", normalized);
  i18next.init({
    lng: normalized,
    resources: require(`../_lang/${normalized}.json`),
  });
  applyLangClass(normalized);
  return true;
};
